export default __webpack_public_path__ + "static/media/chrome_web.be1a5fec.svg";